import React from "react"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import { BlogTabData } from "@/pages/blog/index"
import Link from "next/link"
import { useRouter } from "next/router"
import { useTranslation } from "next-i18next"

export default function HotTags() {
  const { locale } = useRouter()
  const { t } = useTranslation("common")

  return (
    <Wrapper>
      <TitleWrapper>
        <h3>{t("hot-tags")}</h3>
      </TitleWrapper>
      <TagsList>
        {BlogTabData.map(({ id }) => (
          <Link href={`/${locale}/blog#${id}`} passHref key={id} legacyBehavior>
            <span>{t(id)}</span>
          </Link>
        ))}
      </TagsList>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
`

const TitleWrapper = styled.div`
  h3 {
    font-weight: 900;
    font-size: 24px;
    // margin: 0;
    // margin-left: 16px;
    position: relative;
  }
  // &:before {
  //   content: "";
  //   width: 100%;
  //   height: 30px;
  //   border-left: 4px solid ${themeGet("colors.primary")};
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  // }
`

const TagsList = styled.div`
  font-size: 16px;
  flex-wrap: wrap;
  display: flex;
  gap: 0.75em;
  span {
    display: block;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 0.25em;
    cursor: pointer;
    padding: 8px 8px 8px 8px;
    transistion: 0.3s;
    // &:before {
    //   content: "#";
    // }
    :hover {
      // color: ${themeGet("colors.primary")};
      background: rgba(255, 255, 255, 0.3);
    }
  }
`
